import { render, staticRenderFns } from "./CartScreen.vue?vue&type=template&id=7afab885&"
import script from "./CartScreen.vue?vue&type=script&lang=js&"
export * from "./CartScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports